import './common/sentry';

import { createConsentService } from '@aviv-csnt/core';
import { initCriteo, sendCriteoEvent } from '@ma-js-common/criteo-helpers';
import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';

import { initAdjustBanner } from './common/adjust-banner';
import App from './common/app';
import { evaluationFormReady as Contact } from './common/contact';
import { initDatadog } from './common/datadog';
import Ga from './common/ga';
import { redirectObfuscateLink } from './common/obfuscateLink';
import Realytics from './common/realytics.es6';
import Wa from './common/wa';
import { domReady as ContactLanding } from './pages/contact-landing.es6';
import { domReady as DVFTransactions } from './pages/dvf/dvf-transactions';
import { domReady as DVFLanding } from './pages/dvf/landing';
import { domReady as FollowUp } from './pages/followup.es6';
import { domReady as Howto } from './pages/howto.es6';
import { domReady as ListingLanding } from './pages/listings/landing.es6';
import * as Listing from './pages/listings/listing.es6';
import { domReady as ListingSearch } from './pages/listings/search.es6';
import { domReady as PastSalePage } from './pages/past-sale';
import { domReady as PastSalesReportResult } from './pages/past-sales-report/result';
import { initializeModal as Press } from './pages/press/press';
import { domReady as Prices } from './pages/prices';
import { domReady as Realtor } from './pages/realtor.es6';
import { domReady as RealtorsIndex } from './pages/realtors/index';
import { domReady as Realtors } from './pages/realtors/realtors.es6';
import { domReady as RenewPassword } from './pages/renew-password.es6';
import { domReady as FAQ } from './pages/support/faq';
import Auth from './auth';
import { domReady as Error } from './error';

import '../sass/main.scss';

$(() => {
    App.initialize();
    if (MA.Context.requestIsError) {
        Error();
        return;
    }

    const { endpoint } = MA.Context;
    MA.Context.waData.pageview_id = uuidv4();
    const consentCallback = consentItems => {
        const isServiceConsented = serviceName => {
            return Object.values(consentItems).find(item => {
                return item.name === serviceName;
            })?.consent;
        };
        // Realytics
        if (isServiceConsented('Realytics')) {
            Realytics.initialize();
        }

        // Datadog
        if (isServiceConsented('Datadog Real User Monitoring')) {
            initDatadog();
        }

        // Criteo
        if (isServiceConsented('Criteo')) {
            initCriteo(MA.Config.CRITEO_ID, window.MA_USER.username);
        }
    };

    createConsentService('gxmp7r7GKwtteD', {
        enableTCF: false,
        onBannerInteraction(event) {
            if (event.event === 'acceptButtonPressed') {
                window.thor.onConsent();
                Ga.initializeTracking();
            }
            consentCallback(event.consentItems);
        },
    }).then(({ getIsConsentGranted, getConsentItems }) => {
        if (getIsConsentGranted() === true) {
            window.thor.onConsent();
            Ga.initializeTracking();
        }
        consentCallback(getConsentItems());
    });

    initAdjustBanner();

    const viewPageEvent = { event: 'viewPage' };

    switch (endpoint) {
        case 'prices_bp.index':
            Wa.setTracking($('body'), MA.Context.waData);
            Prices(MA.Context.mapPlace, MA.Context.placePrices);
            sendCriteoEvent(viewPageEvent);
            break;
        case 'prices_bp.region':
        case 'prices_bp.subregion':
        case 'prices_bp.city':
        case 'prices_bp.arrmun':
        case 'prices_bp.borough':
        case 'prices_bp.street':
        case 'prices_bp.address':
            Wa.setTracking($('body'), MA.Context.waData);
            Prices(MA.Context.mapPlace, MA.Context.placePrices);
            break;
        case 'auth_bp.signin2':
            Auth.domReady();
            Auth.authAnalytics.apply(null, MA.Context.authAnalytics);
            Auth.setSessionStorage();
            break;
        case 'about_bp.press_room':
            Wa.setTracking();
            break;
        case 'about_bp.terms':
            Wa.setTracking();
            break;
        case 'realtors_bp.realtors':
            Wa.setClickTracking();
            RealtorsIndex();
            sendCriteoEvent(viewPageEvent);
            break;
        case 'auth_bp.renew_password':
            RenewPassword();
            break;
        case 'realtors_bp.place':
        case 'realtors_bp.address':
        case 'realtors_bp.street':
        case 'realtors_bp.subregion':
        case 'realtors_bp.city':
        case 'realtors_bp.subcity':
        case 'realtors_bp.arrmun':
            Realtors(MA.Context.realtorSearchPlace);
            break;
        case 'realtors_bp.realtor':
            Realtor();
            break;
        case 'contact_bp.evaluation':
            Wa.setClickTracking();
            Contact();
            break;
        case 'past_sales_bp.past_sale_page':
            PastSalePage();
            break;
        case 'past_sales_report_bp.past_sales_report_result':
            PastSalesReportResult();
            break;
        case 'followup_bp.dde_b2c':
        case 'followup_bp.dde_b2b':
            Wa.setClickTracking();
            FollowUp();
            break;
        case 'listings_bp_old.listing_detail':
        case 'listings_bp.listing_detail_rent':
        case 'listings_bp.listing_detail_sell':
            Listing.domReady();
            break;
        case 'listings_bp_old.sale_preview':
            Listing.domPreviewReady();
            break;
        case 'listings_bp.search':
        case 'listings_bp.search_url_seo':
        case 'listings_bp_old.listings_with_city_slug':
            ListingSearch();
            break;
        case 'main_bp.listings_rent':
        case 'main_bp.listings_sell':
            ListingLanding();
            break;
        case 'contact_bp.contact_landing':
            ContactLanding();
            break;
        case 'dvf_transactions_bp.index':
            DVFLanding();
            redirectObfuscateLink();
            Wa.setTracking();
            sendCriteoEvent(viewPageEvent);
            break;
        case 'dvf_transactions_bp.region':
        case 'dvf_transactions_bp.subregion':
        case 'dvf_transactions_bp.city':
        case 'dvf_transactions_bp.arrmun':
        case 'dvf_transactions_bp.borough':
        case 'dvf_transactions_bp.street':
        case 'dvf_transactions_bp.address':
            DVFTransactions();
            Wa.setTracking();
            break;
        case 'support_bp.faq':
            FAQ();
            Wa.setTracking();
            break;
        case String(endpoint.match(/estima_howto_bp.*/)):
            Wa.setClickTracking();
            Howto();
            break;
        case 'howto_bp.sale_success':
        case 'howto_bp.choose_realtor':
        case 'howto_bp.understand_market':
            Wa.setTracking();
            sendCriteoEvent(viewPageEvent);
            break;
        case 'about_bp.press':
            Wa.setClickTracking();
            Press();
            break;
        case 'prices_bp.place_streets':
        case 'main_bp.terms':
            redirectObfuscateLink();
            break;
        default:
            Wa.setClickTracking();
            window.console.warn('Unknown endpoint', endpoint);
    }
});
